// extracted by css-extract-rspack-plugin
export default {"link":"footer-fragment__HelpLink_link__tIxB8","chevron":"footer-fragment__HelpLink_chevron__68Cuf"};